import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column is-flex is-align-items-center" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play" }, null, -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pause" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StopWacth = _resolveComponent("StopWacth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StopWacth, { timeSeconds: _ctx.timeSeconds }, null, 8, ["timeSeconds"]),
    _createElementVNode("button", {
      type: "button",
      class: "button btn-timer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args))),
      disabled: _ctx.checker
    }, [
      _hoisted_3,
      _createTextVNode("Start ")
    ], 8, _hoisted_2),
    _createElementVNode("button", {
      type: "button",
      class: "button btn-timer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.end && _ctx.end(...args))),
      disabled: !_ctx.checker
    }, [
      _hoisted_5,
      _createTextVNode("Stop ")
    ], 8, _hoisted_4)
  ]))
}